import {
  PermissionValues,
  Product,
  useCurrentAccount,
  useDeleteMutation,
} from '@gripp/shared-logic';
import { Colors, CustomAlert } from '@gripp/shared-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Pressable, StyleSheet } from 'react-native';
import { Text } from 'react-native-paper';

type DeleteProductProps = {
  product?: Product;
  onDeleted: () => void;
};

export const DeleteProduct = (props: DeleteProductProps) => {
  const [showAlert, setShowAlert] = useState(false);
  const { account } = useCurrentAccount();
  const { t } = useTranslation();
  const { mutateAsync } = useDeleteMutation({
    modelName: 'product',
    query: DELETE_PRODUCT,
  });

  const onDelete = async () => {
    const product = props.product;
    if (!product) return;

    const input = {
      id: product.id,
    };

    await mutateAsync({ input });
    await props.onDeleted();
  };

  return (
    account?.hasPermission(PermissionValues.product.delete) && (
      <>
        <Pressable onPress={() => setShowAlert(true)}>
          <Text variant="titleMedium" style={styles.deleteText}>
            {t('product.delete.button')}
          </Text>
        </Pressable>
        <CustomAlert
          visible={showAlert}
          hideAlert={() => setShowAlert(false)}
          action={onDelete}
          title={t('product.delete.title', {
            productName: props.product?.name,
          })}
          primaryButtonLabel={t('product.delete.confirm')}
          secondaryButtonLabel={t('product.delete.cancel')}
        />
      </>
    )
  );
};

const DELETE_PRODUCT = `
  mutation Mutation($input: MutateProductInput!) {
    deleteProduct(input: $input) {
      id
    }
  }
`;

const styles = StyleSheet.create({
  deleteText: {
    color: Colors.red,
    paddingVertical: 20,
  },
});
